<template>
  <div>    
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>     
    <v-container v-else grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="8" cols="12">
                <v-layout column class="pa-5">
                    <v-hover v-slot:default="{ hover }">
                        <v-btn to="/cpanel/sms" dark :color="hover?'primary':'secondary'">Messages</v-btn>
                    </v-hover> 
                    <br>
                     <v-hover v-slot:default="{ hover }">
                        <v-btn to="/cpanel/services" dark :color="hover?'primary':'secondary'">services</v-btn>
                    </v-hover>
                    <br>
                     <v-hover v-slot:default="{ hover }">
                        <v-btn to="/cpanel/sisters" dark :color="hover?'primary':'secondary'">sisters</v-btn>
                    </v-hover>
                    <br> 
                    <v-hover v-slot:default="{ hover }">
                        <v-btn to="/cpanel/communities" dark :color="hover?'primary':'secondary'">COMMUNITIES</v-btn>
                    </v-hover>
                    <br> 
                    <v-hover v-slot:default="{ hover }">
                        <v-btn to="/cpanel/images" dark :color="hover?'primary':'secondary'">GALLERY IMAGES</v-btn>
                    </v-hover>
                    <br> 
                    <br>  
                </v-layout>
            </v-col>  
        </v-layout>
    </v-container> 
    
  </div> 
</template>

<script>
let pageName = "Cpanel"
    export default {
        name:pageName,
        props:["not"],
        data() {
        return {
            page_show:false,
            dialogMessage: false,
            load:false,
            input_name:'',
            input_email:'',
            input_phoneNumber:'',
            input_address:'',
            input_message:'',
            tab: null,
            items: [
                'Login', 'Register', ,
            ], 
            images:[
                {src:require(`@/assets/awrim/group/g4.jpeg`),local:true},  
            ] 
        }
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"250",
                notImages:this.images
            })
            this.pageLoad(500)
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
        },
        methods: {
            clicked(){},
            //LOAD
            show(){
                if (!this.us) {
                    this.not.go("/")
                }
            },
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {  
                        this.show()
                        this.page_show = true
                    }  
                },t)
            }
        },
        watch: {
            us(v){
                this.show()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
